// UI-level presentation helpers for the branded-fare-upsell components.
// Offer-shape utilities live in @liveflight/utilities/flight-offer;
// fare-choice pipeline helpers live on the provider — no re-exports here.

export const show_amenity = (amenity) => !amenity.isChargeable;

export const get_fare_button_text = (
  item,
  selected_flight_offer_id,
  flight_offer_default,
) => {
  if (item.id === selected_flight_offer_id) {
    if (item.id === flight_offer_default.id) {
      return "Default";
    }
    return "Rimuovi";
  }
  return "Scegli";
};

export const is_amenity_present = (offers_amenities, offer_id, amenity_code) =>
  (offers_amenities[offer_id] || []).includes(amenity_code);

export const toggle_selected_class = (item, selected_flight_offer_id) =>
  item.id === selected_flight_offer_id ? "selected" : "";
